import isEqual from "lodash/isEqual";
import { createRecord } from "Utils";
const createHiddenEdgeJSON = (id, source, target) => ({
    Id: id,
    Source: source,
    Target: target,
    Bends: [],
    SourcePort: null,
    TargetPort: null
});
export const prepareEdges = ({ documentGraphData, prevData }) => {
    var _a;
    const edgeSourceForServer = new Map();
    const prevEdges = createRecord(prevData.Edges, "Id");
    const edgesOnGraph = new Map(documentGraphData.Edges.map(item => [item.Id, item]));
    const edgesForServer = new Map();
    const addEdgeSourceForServer = (item) => {
        var _a;
        if (item) {
            edgeSourceForServer.set(item.EdgeId, item);
            edgesForServer.set(item.EdgeId, (_a = edgesOnGraph.get(item.EdgeId)) !== null && _a !== void 0 ? _a : createHiddenEdgeJSON(item.EdgeId, item.From, item.To));
        }
    };
    (_a = documentGraphData.EdgesSource) === null || _a === void 0 ? void 0 : _a.forEach(item => {
        const prev = prevData.EdgesSource[item.EdgeId];
        if (!prev) {
            addEdgeSourceForServer(item);
            return;
        }
        if (isEqual(prev, item)) {
            return;
        }
        addEdgeSourceForServer(item);
    });
    documentGraphData.Edges.forEach(item => {
        if (edgesForServer.has(item.Id)) {
            return;
        }
        const prev = prevEdges[item.Id];
        if (isEqual(prev, item)) {
            return;
        }
        const prevSource = prevData.EdgesSource[item.Id];
        addEdgeSourceForServer(prevSource);
    });
    return {
        edgeSourceForServer,
        edgesForServer
    };
};
